import { useTranslation } from 'react-i18next';

export const ServiceVariableTooltipVal = () => {
  const { t: translate } = useTranslation();
  return (
    <>
      {String(translate('service_details_form_component.service_variable_tooltip_title'))}<br />
      {String(translate('service_details_form_component.service_variable_tooltip_format'))}<br />
      {String(translate('service_details_form_component.service_variable_tooltip_example_val'))}<br />
      {String(translate('service_details_form_component.service_variable_tooltip_azure'))}
    </>
  );
};
